import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateBettingMarket } from "@/api/bettingMarkets";
import { BettingMarketsQueryKeys } from "@/tanstackQuery/queries/bettingMarkets";
import { UpdateBettingMarketParams } from "@/types/ApiResponses/BettingMarket";

export const useUpdateBettingMarket = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateBettingMarketParams) => updateBettingMarket(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BettingMarketsQueryKeys.BettingMarkets] });
    },
  });
};
